import script from "./CoefficientsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoefficientsTable.vue?vue&type=script&setup=true&lang=ts"

import "./CoefficientsTable.vue?vue&type=style&index=0&id=d3ed21e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3ed21e8"]])

export default __exports__